// @flow
import $ from "jquery";
import debounce from "./debounce";
import validateImageMinSize from "./validateImageMinSize";
import validateMaxWidthHeight from "./validateMaxWidthHeight";
import validateFileMaxSize from "./validateFileMaxSize";

export default (options) => {
	$.widget("blueimp.fileupload", $.blueimp.fileupload, {
		processActions: {
			debounce(data: Object) {
				return debounce(this, data);
			},

			validateImageMinSize(data: Object) {
				return validateImageMinSize(this, data, options);
			},

			validateMaxWidthHeight(data: Object) {
				return validateMaxWidthHeight(this, data, options);
			},

			validateFileMaxSize(data: Object) {
				return validateFileMaxSize(this, data);
			},
		},
	});
};
